import { render } from "./WordFormPage.vue?vue&type=template&id=2cd50926&ts=true"
import script from "./WordFormPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./WordFormPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/word/WordFormPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cd50926"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cd50926', __exports__)) {
    api.reload('2cd50926', __exports__)
  }
  
  module.hot.accept("./WordFormPage.vue?vue&type=template&id=2cd50926&ts=true", () => {
    api.rerender('2cd50926', render)
  })

}


export default __exports__